<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import YwfzqkdjBrowse from "./YwfzqkdjBrowse";
import YwfzqkdjEdit from "./YwfzqkdjEdit";
import YwfzqkdjForm from "./YwfzqkdjForm";
export default {
    name: "Ywfzqkdj",
    components: { YwfzqkdjBrowse, YwfzqkdjEdit, YwfzqkdjForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "YwfzqkdjEdit";
            } else if (this.editProps.showForm === true) {
                return "YwfzqkdjForm";
            } else {
                return "YwfzqkdjBrowse";
            }
        }
    }
};
</script>
